import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Box, VStack } from "@chakra-ui/react";
export const CardContainer = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Box px="8" py="8" zIndex="docked" w="full"><VStack gap="3.5">{children}</VStack></Box>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};